import template from './userCardList.html';
import controller from './userCardList.controller';
import './userCardList.scss';

let userCardListComponent = {
  restrict: 'E',
  bindings: {
    newCardState: '<',
    employees: '<',
    onModify: '&',
    onSendCard: '&',
    cardDaysFocused: '&',
    onCloseCard: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default userCardListComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardList.component.js